<template>
	<transition-group ref="container" tag="div" name="vacancies">
		<contentblock
			v-for="(vacancy, index) in items"
			:key="vacancy.pageID"
			:index="index"
			:class="{ active: filter === vacancy.category || filter === 'showAll' }"
		>
			<template #contentblock-content>
				<div v-if="vacancy.date" class="date">
					<span>{{ $d(new Date(vacancy.date.date.split(' ')[0]), 'short') }}</span>
				</div>
				<h2>{{ vacancy.title || vacancy.header }}</h2>
				<div v-parse-links v-html="vacancy.overviewContent" />
				<nuxt-link
					v-if="defaults[locale].vacancies.view"
					:to="localePath(`/${vacancy.filename}`)"
					class="button button-no-fill"
				>
					{{ defaults[locale].vacancies.view }}
				</nuxt-link>
			</template>
			<template #contentblock-image>
				<nuxt-link :to="localePath(`/${vacancy.filename}`)">
					<picture>
						<source :srcset="vacancy.overviewImageWebp" type="image/webp" />
						<source :srcset="vacancy.overviewImage" />
						<img
							loading="lazy"
							:src="vacancy.overviewImage"
							:alt="vacancy.overviewImageAlt"
							class="object-fit"
						/>
					</picture>
				</nuxt-link>
			</template>
		</contentblock>
	</transition-group>
</template>

<script setup>
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchDefaults();

defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});
</script>

<style lang="scss">
.vacancies-move {
	transition: transform 0.5s;
}

.vacancies-enter-active {
	transition: all 0.3s ease-out;
}

.vacancies-leave-active,
.vacancies-enter-from {
	position: absolute;
	opacity: 0;
}

.vacancies-enter-from {
	transform: translateY(10px);
}
</style>

<style lang="scss">
.date {
	margin: 5px 0 10px;
}
</style>
